module.exports = __webpack_public_path__ + "static/media/1-1.6c240f01.png";